import React from 'react';

function EducationCard({ degree, institution, gpa, year, gpaLabel }) {
    return (
        <div className="flex flex-col gap-2 p-5 rounded-xl border border-slate-200 dark:border-[#324467] bg-white dark:bg-[#1a2333]">
            <div className="flex justify-between items-start">
                <h3 className="text-lg font-bold">{degree}</h3>
                {gpa && (
                    <span className="bg-primary/10 text-primary dark:text-sky-300 text-xs font-bold px-2 py-1 rounded">
                        {gpaLabel || 'GPA'}: {gpa}
                    </span>
                )}
            </div>
            <p className="text-slate-600 dark:text-[#92a4c9] text-sm font-medium">{institution}</p>
            <p className="text-slate-500 text-xs">{year}</p>
        </div>
    );
}

export default EducationCard;
